// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sWeiPs {
    position: relative;
    display: inline-block;
    width: 48px;
    height: 24px;
    box-sizing: border-box;
}

.n4R1Bm {
    opacity: 0;
    top: 0;
    left: 0;
    margin: 0;
    padding: 0;
    cursor: inherit;
}

.Hke9cw {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;

    color: #cbd3dc;
    cursor: pointer;
}

.Q2HHot {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;

    background-color: currentColor;
    border-radius: 12px;
    transition: all 300ms ease;
}

input:focus-visible:not(:active) + .Hke9cw .Q2HHot {
    box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #116dff !important;
}

.Hke9cw:hover {
    color: #dfe5eb;
}

.Hke9cw:active {
    color: #cbd3dc;
}

.n4R1Bm:checked + .Hke9cw:hover {
    color: #4c4c4c;
}

.n4R1Bm:checked + .Hke9cw,
.n4R1Bm:checked + .Hke9cw:active,
.n4R1Bm:checked + .Hke9cw:active:hover {
    color: #000;
}

.w9iGn_ {
    position: absolute;
    left: 1px;
    top: 1px;
    width: 22px;
    height: 22px;
    border-radius: 12px;

    transition: all 300ms ease;
    display: flex;
    align-items: center;
    justify-content: center;

    background: #fff;
    box-shadow:
        0 2px 1px 0 rgba(22,45,61,.48),
        0 0 3px 0 rgba(22,45,61,.12);
}

.n4R1Bm:checked + label .w9iGn_ {
    left: calc(50% + 1px);
}

.yXDt4H {
    width: 11px;
    height: 11px;
    transition: opacity 300ms ease;
    margin-top: 1px; /* this icon is misaligned */
}

.n4R1Bm:not(:checked) + label .dSIa_x,
.n4R1Bm:checked + label .SNCgaV {
    opacity: 0;
    display: none;
}


@media (max-width: 375px) {
    .sWeiPs {
        width: 36px;
        height: 20px;
    }

    .w9iGn_ {
        width: 18px;
        height: 18px;
        border-radius: 9px;
    }

    .n4R1Bm:checked + label .w9iGn_ {
        left: calc(50% - 1px);
    }

    .yXDt4H {
        width: 9px;
        height: 9px;
    }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toggle": `sWeiPs`,
	"input": `n4R1Bm`,
	"label": `Hke9cw`,
	"track": `Q2HHot`,
	"knob": `w9iGn_`,
	"icon": `yXDt4H`,
	"iconTrue": `dSIa_x`,
	"iconFalse": `SNCgaV`
};
export default ___CSS_LOADER_EXPORT___;
